export const CURRENCY = {
  EUR: "EUR",
  USD: "USD",
};

const CURRENCY_TO_LOCALE = {
  EUR: "nl-NL",
  USD: "en-US",
};

/**
 *
 * @param {number} num
 */
function isFractional(num) {
  return num % 1 !== 0;
}

/**
 *
 * @param {number | string} number
 * @param {string} currency
 * @param {boolean} trimTrailingZeros
 * @return {string}
 * @example
 * formatCurrency(108, "EUR")
 * // returns € 108,00
 */
export const formatCurrency = (
  number,
  currency = CURRENCY.EUR,
  trimTrailingZeros = false,
) => {
  // @ts-ignore
  const locale = CURRENCY_TO_LOCALE[currency] || "nl-NL";

  const asNumber = typeof number === "number" ? number : parseFloat(number);
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    maximumFractionDigits: trimTrailingZeros && !isFractional(asNumber) ? 0 : 2,
  });

  return formatter.format(asNumber);
};
